import { makeEvent } from "~/lib/signals";
import { node } from "~/util/dom";
import { createNotificationItem, INotificationItem } from "~/util/notifications/item";

interface INotificationEvent {
	type: NOTIFICATIONS_TYPE;
	duration?: number;
	autohide?: boolean;
	content: string | HTMLElement;
	action?: HTMLElement;
}

export enum NOTIFICATIONS_TYPE {
	SUCCESS = 0,
	ERROR = 1,
	QUESTION = 2,
	INFO = 3,
}

const DURATION = 3000;

class Notifications {
	#container: HTMLUListElement;

	#items: Array<INotificationItem>;

	constructor() {
		this.#container = node("ul", { className: "notifications" });
		this.#items = [];
	}

	destroy() {
		this.hideAll();
	}

	hideAll(exceptions = []) {
		for (let index = this.#items.length - 1; index >= 0; index--) {
			if (exceptions.indexOf(this.#items[index].type) === -1) {
				this._hide(this.#items[index]);
			}
		}
	}

	get container() {
		return this.#container;
	}

	notify(event: INotificationEvent) {
		const item = createNotificationItem(event, notification => this._hide(notification));

		this._show(item);

		if (event.type === NOTIFICATIONS_TYPE.INFO || event.type === NOTIFICATIONS_TYPE.SUCCESS || event.autohide) {
			setTimeout(() => this._hide(item), event.duration || DURATION);
		}

		return item.id;
	}

	_show(item) {
		this.#items.push(item);

		for (let zi = this.#items.length; zi > 0; zi--) {
			this.#items[zi - 1].container.style.zIndex = (this.#items.length - zi).toString();
		}

		this.#container.appendChild(item.container);
	}

	_hide(item) {
		const index = this.#items.indexOf(item);

		if (index > -1) {
			item.container.classList.add("hidding");
			item.container.addEventListener("animationend", event => {
				if (event.animationName === "close") {
					item.container.remove();
					item.container.innerHTML = "";
					makeEvent("notifications-close", this, { id: item.id });
					this.#items.splice(index, 1);
				}
			});
		}
	}
}

export default new Notifications();
